module.exports = __webpack_public_path__ + "static/ledeck_bg-f66946e29849a02a537eb6ecd92f6b7a.jpg";